// extracted by mini-css-extract-plugin
export default {"section":"FolderProgress_section__5sV+-","row":"FolderProgress_row__EFVIM","col":"FolderProgress_col__U-kVC","card":"FolderProgress_card__qMhcy"};